import { dashboardSliceActions } from './dashboardSlice';

export const dashboardActions = {
  ...dashboardSliceActions,
};
